document.addEventListener('DOMContentLoaded', function () {
  adjustTypography()
})

function adjustTypography () {
  // Adding 'typography-h5' to all heading in the career-article
  const careerArticle = document.getElementsByClassName('career-article')

  for (item of careerArticle) {
    const headings = item.querySelectorAll('h1, h2, h3, h4, h5, h6')
    for (head of headings) {
      head.classList.add('typography-h5')
    }

    const pTags = item.querySelectorAll('p')
    for (p of pTags) {
      if (p.innerText) {
        p.classList.add('no-empty-p')
      }
    }
  }
}
